import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Orderer extends BaseApi{
  static getClassName(){ return 'Orderer' }

  static get(input){
    return app.make("axios").get(`v1/account/orderer/index`,{
      params: {
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static save(input){
    return app.make("axios").post(`v1/account/orderer/create`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }


}
export default Orderer



// WEBPACK FOOTER //
// ./src/api/Orderer.js